import { useQuery } from '@tanstack/react-query';
import {
  ExperienceResource,
  experiencesGet,
  RouteResource,
  ServiceEventResource,
  ShiftResource,
  TurnResource,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

type UseExperienceOptions = {
  experienceId: number;
  expand?: string[];
};

export const useExperience = ({
  experienceId,
  expand,
}: UseExperienceOptions) => {
  return useQuery({
    queryFn: () => {
      const data = extractData(
        experiencesGet({
          path: { id: experienceId },
          query: { expand },
        })
      );
      return data as unknown as Omit<ExperienceResource, 'events' | 'turn'> & {
        events: ServiceEventResource[];
        turn: Omit<TurnResource, 'shift' | 'route'> & {
          shift: ShiftResource;
          route: RouteResource;
        };
      };
    },
    queryKey: ['Experiences', experienceId, { expand }],
  });
};
